import { render } from "./AppPriceFilter.vue?vue&type=template&id=2a885db2&scoped=true"
import script from "./AppPriceFilter.vue?vue&type=script&lang=js"
export * from "./AppPriceFilter.vue?vue&type=script&lang=js"

import "./AppPriceFilter.vue?vue&type=style&index=0&id=2a885db2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a885db2"]])

export default __exports__